import { NgModule } from '@angular/core'
import { ButtonStrokedDirective } from './button-stroked.directive'

@NgModule({
    declarations: [ButtonStrokedDirective],
    exports: [ButtonStrokedDirective]
})
export class ButtonStrokedModule {}
